export enum TenantIdType {
    CUDD = 1,
    TTS = 2,
}
